module.exports = __webpack_public_path__ + "static/media/33.281eee9d.png";